export default __webpack_public_path__ + "static/media/week-analysis.19d8c8c9.svg";